import React, { useEffect, useState } from "react";
import "./ReportAndMenuAssign.scss";
import { Breadcrumb, Modal } from "react-bootstrap";
import EziLoader from "components/EziLoader";
import Axios from "utility/Axios";
import configURL from "config/config";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from 'react-select';
import { outlineRemove } from 'utility/helper';
import { DndContext, closestCenter } from "@dnd-kit/core";
import SortableMenuItem from "./SortableMenuItem";
import { SortableContext, verticalListSortingStrategy, arrayMove } from "@dnd-kit/sortable";
import InsightDashboardPreview from "./InsightMenu/InsightDashboardPreview";
import EmptyDashboardState from "./ReportMenus/EmptyDashboardState";
import QuestionAnalysisPreview from './ReportMenus/QuestionAnalysisPreview';
import RespondentPreview from "./ReportMenus/RespondentPreview";
import ResponseRatePreview from "./ReportMenus/ResponseRatePreview";
import CultureMapPreview from "./ReportMenus/CultureMapPreview";
import DownloadReportPreview from "./ReportMenus/DownloadReportPreview";
import TrendPreview from "./CeodbMenus/TrendPreview";
import OverviewPreview from "./CeodbMenus/OverviewPreview";
import AllCommentsPreview from "./CeodbMenus/AllCommentsPreview";
import MoodOMeterPreview from "./CeodbMenus/MoodOMeterPreview";
import DemographicComparator from "./CeodbMenus/DemographicComparator";
import StatementWisePreview from "./CeodbMenus/StatementWisePreview";
import ManagerInsights from "../../assets/images/ManagerInsight.png";

const ReportAndMenuAssign = () => {
    const [loading, setLoading] = useState(false);
    const [reportList, setReportList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedReport, setSelectedReport] = useState(null);
    const [selectedMenu, setSelectedMenu] = useState([]);
    const [selectedMenuOption, setSelectedMenuOption] = useState([]);
    const [selectedMenus, setSelectedMenus] = useState([]);
    const [reArrangeMenuOption, setReArrangeMenuOption] = useState([]);
    const [reportType, setReportType] = useState([]);
    const [allReportTypeMenu, setAllReportTypeMenu] = useState([]);
    const [formatedJSON, setFormatedJSON] = useState([]);
    const [insightConfig, setInsightConfig] = useState(null);
    const [reportConfiguration, setReportConfiguration] = useState({ average_toggle: false, date_range: "daterange" });
    const [activePreviewMenu, setActivePreviewMenu] = useState(null);
    const [reportName, setReportName] = useState("");
    const navigate = useNavigate();
    const urlParams = useParams();
    const location = useLocation()
    const companyName = location?.state?.company_name

    /* ---------------- GET MASTER REPORT TYPES ---------------- */

    const getReportType = () => {
        let formData = new FormData();
        formData.append("is_partner_report_type", true);
        Axios.post(configURL.get_partner_report_types_mapping, formData).then(response => {
            if (response.data.success) {
                let typesData = [];
                let menu = [];
                response?.data?.data?.forEach(element => {
                    typesData.push({
                        value: element.report_type_id,
                        label: element.name,
                        ui_config: element.master_configuration_json?.ui_config
                    });
                    let parsedData = JSON.parse(element.master_configuration_json?.ui_config)
                    menu.push({ [element.report_type_id]: parsedData?.menu || [] });
                });
                setAllReportTypeMenu(menu);
                setReportList(typesData);
            }
            setLoading(false);
        }).catch(() => setLoading(false));
    };

    /* ---------------- GET STORED ACCOUNT DATA ---------------- */

    const getStoreAccoutData = () => {
        let formData = new FormData();
        urlParams?.account_id && formData.append("account_id", urlParams.account_id);
        Axios.post(configURL.get_store_or_update_company_data, formData).then(response => {
            if (response.data.success) {
                const data = response.data.data.report_types || [];
                const report = data.map(item => ({
                    label: item.report_type_name || "",
                    value: item.report_type_id || "",
                    ui_config: {
                        menu: item?.ui_config?.menu || [],
                        menu_components: item?.ui_config?.menu_components || {
                            insight: null
                        },
                        ReportConfiguration:
                        {
                            average_toggle: item?.ui_config?.ReportConfiguration?.average_toggle || false,
                            date_range: item?.ui_config?.ReportConfiguration?.date_range || "daterange"
                        }
                    }
                }));
                setReportType(report);
                setFormatedJSON(
                    report.map(item => ({
                        report_type_id: item.value,
                        report_type_name: item.label,
                        ui_config: item.ui_config
                    })));
            }
        }).catch(err => {
            console.log(err);
        })
    };

    /* ---------------- SAVE ---------------- */

    const saveReportWiseMenu = () => {
        let reportOptions = formatedJSON?.find(report => report?.report_type_id === selectedReport?.value)
        if (reportOptions?.ui_config?.menu?.length === 0) {
            toast.warn("Please select at least one menu");
            return;
        }
        if (reportOptions?.ui_config?.menu?.find(menu => menu?.label === "Insight")) {
            if ((reportOptions?.ui_config?.menu_components?.insight?.speedometer === false) && reportOptions?.ui_config.menu_components?.insight?.tabs.length === 0) {
                toast.warn("Please Select atleast one widget for the Insight.")
                return;
            }
        }
        if (!formatedJSON?.length) return;
        let formData = new FormData();
        formData.append("report_types", JSON.stringify(formatedJSON.filter(itm => itm.report_type_id)));
        urlParams?.account_id && formData.append("account_id", urlParams.account_id);
        Axios.post(configURL.store_or_update_company_data, formData).then(response => {
            if (response.data.success) {
                getStoreAccoutData();
                setShowModal(false);
                setSelectedMenu([]);
                setSelectedReport(null);
                setActivePreviewMenu(null);
                toast.success(response.data.message);
            } else {
                toast.warn(response.data.message);
            }
        }).catch(err => {
            console.log(err);
        })
    };

    /* ---------------- HELPERS ---------------- */

    const formateSelectMenuOption = (label) => {
        return label?.label.toLowerCase().split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
    };
    /* ---------------- OPEN CONFIG MODAL ---------------- */

    const handleReportWiseMenu = (data) => {
        setReportName(data?.label)
        setReArrangeMenuOption([]);
        setSelectedReport(data);
        setShowModal(true);
    };

    const handleReportMenuSelect = (value, actionMeta) => {
        const selected = value || [];
        setSelectedMenus(selected.map(item => item.label));
        setActivePreviewMenu(selected[0]?.label || "");
        setSelectedMenu(selected);
        if (actionMeta?.action === "select-option") {
            const selectedKeys = selected.map(s => s.value.key);
            setSelectedMenuOption(prev =>
                prev.filter(opt => !selectedKeys.includes(opt.value.key))
            );
        }
        if (actionMeta?.action === "remove-value" || actionMeta?.action === "pop-value") {
            const removed = actionMeta?.removedValue;
            setSelectedMenuOption(prev => {
                const exists = prev.some(opt => opt.value.key === removed.value.key);
                if (exists) return prev;
                return [...prev, removed];
            });
        }
        if (actionMeta?.action === "clear") {
            if (!selectedReport || !selectedReport.value) {
                setSelectedMenu([]);
                setSelectedMenus([]);
                setSelectedMenuOption([]);
                setActivePreviewMenu(null);
                return;
            }
            const menuOption = allReportTypeMenu.find(item => Object.keys(item)[0] === selectedReport.value);
            let masterMenuArray = [];
            if (menuOption && menuOption[selectedReport.value]) {
                masterMenuArray = menuOption[selectedReport.value];
            }
            const allOptions = masterMenuArray.map(m => ({
                label: formateSelectMenuOption(m),
                value: m
            }));
            setSelectedMenu([]);
            setSelectedMenus([]);
            setReArrangeMenuOption([]);
            setSelectedMenuOption(allOptions);
            setActivePreviewMenu(null);
        }
    };

    /* ---------------- DRAG REORDER ---------------- */

    const handleOnDragEnd = ({ active, over }) => {
        if (!over || active.id === over.id) return;
        setSelectedMenus(items => {
            const newOrder = arrayMove(
                items,
                items.indexOf(active.id),
                items.indexOf(over.id)
            );
            setReArrangeMenuOption(newOrder);
            return newOrder;
        });
    };

    /* ---------------- UPDATE formatedJSON ---------------- */

    useEffect(() => {
        if (!reportType?.length) return;
        const normalizedReportType = reportType.map(rpt => {
            let parsedConfig = rpt.ui_config;
            if (typeof rpt.ui_config === "string") {
                try {
                    parsedConfig = JSON.parse(rpt.ui_config);
                } catch (e) {
                    console.error("Failed to parse ui_config for", rpt.label, e);
                    parsedConfig = {};
                }
            }
            return {
                ...rpt,
                ui_config: parsedConfig || {}
            };
        });
        setFormatedJSON(prev => {
            let next = [];
            for (const rpt of normalizedReportType) {
                const existing = prev.find(
                    item => item.report_type_id === rpt.value
                );
                if (existing) {
                    next.push({
                        ...existing,
                        ui_config: {
                            ...existing.ui_config,
                            menu: rpt.ui_config?.menu || existing.ui_config?.menu || [],
                            menu_components: rpt.ui_config?.menu_components || existing.ui_config?.menu_components || {
                                insight: null
                            },
                            ReportConfiguration: {
                                average_toggle:
                                    reportConfiguration.average_toggle ??
                                    false,

                                date_range:
                                    reportConfiguration?.date_range ??
                                    "daterange"
                            }
                        }
                    });
                } else {
                    next.push({
                        report_type_id: rpt.value,
                        report_type_name: rpt.label,
                        ui_config: {
                            menu: rpt.ui_config?.menu || [],
                            menu_components: rpt.ui_config?.menu_components || {
                                insight: null
                            },
                            ReportConfiguration: {
                                average_toggle: rpt?.ui_config?.ReportConfiguration?.average_toggle || false,
                                date_range: rpt?.ui_config?.ReportConfiguration?.date_range || "daterange"
                            }
                        }
                    });
                }
            }
            if (!selectedReport?.value) {
                return next;
            }
            let option = [];
            if (reArrangeMenuOption?.length > 0) {
                const map = Object.fromEntries(
                    selectedMenu.map(({ label, value }) => [label, value])
                );
                option = reArrangeMenuOption.map(label => map[label]).filter(Boolean);
            } else {
                option = selectedMenu.map(item => item.value);
            }
            return next.map(item => {
                if (item.report_type_id !== selectedReport.value) return item;
                return {
                    ...item,
                    ui_config: {
                        menu: option,
                        menu_components: {
                            insight: insightConfig
                                ? {
                                    score_widgets: insightConfig.score_widgets,
                                    speedometer: insightConfig.speedometer,
                                    tabs: insightConfig.tabs
                                }
                                : null
                        },
                        ReportConfiguration: {
                            average_toggle: reportConfiguration?.average_toggle || item.ui_config?.ReportConfiguration?.average_toggle || false,
                            date_range: reportConfiguration?.date_range || item.ui_config?.ReportConfiguration?.date_range || "daterange"
                        }
                    }
                };
            });
        });
    }, [reportType, selectedReport, selectedMenus, reArrangeMenuOption, insightConfig, reportConfiguration]);

    useEffect(() => {
        if (!showModal) return;
        if (!selectedReport) return;
        if (!Array.isArray(allReportTypeMenu) || allReportTypeMenu.length === 0) return;
        if (!Array.isArray(reportType) || reportType.length === 0) return;
        const data = selectedReport;
        const rawUiCfg = reportType.find(itm => itm.value === data.value)?.ui_config;
        let uiCfg = null;
        try {
            if (typeof rawUiCfg === "string") {
                uiCfg = JSON.parse(rawUiCfg);
            } else {
                uiCfg = rawUiCfg;
            }
        } catch (e) {
            uiCfg = null;
        }
        const existingInsight = uiCfg?.menu_components?.insight || uiCfg?.menu_components?.insights || null;
        const existingReportConfig = { average_toggle: uiCfg?.ReportConfiguration?.average_toggle || false, date_range: uiCfg?.ReportConfiguration?.date_range || "daterange" };
        setInsightConfig(existingInsight);
        setReportConfiguration(existingReportConfig)
        const menuOption = allReportTypeMenu.find(item => Object.keys(item)[0] === data?.value);
        let masterMenuArray = [];
        if (menuOption && menuOption[data.value]) {
            masterMenuArray = menuOption[data.value];
        }
        const allOptions = masterMenuArray.map(m => ({
            label: formateSelectMenuOption(m),
            value: m
        }));
        let selected = [];
        if (Array.isArray(uiCfg?.menu) && uiCfg.menu.length > 0) {
            selected = uiCfg.menu.map(m => ({
                label: formateSelectMenuOption(m),
                value: m
            }));
        } else {
            selected = [];
        }
        const selectedKeys = selected.map(s => s.value?.key).filter(Boolean);
        const filteredOptions = allOptions.filter(
            opt => !selectedKeys.includes(opt.value?.key)
        );
        setSelectedMenu(selected);
        setSelectedMenus(selected.map(item => item.label));
        setSelectedMenuOption(filteredOptions);
        setActivePreviewMenu(selected[0]?.label || null);
    }, [showModal, selectedReport, allReportTypeMenu, reportType]);

    /* ---------------- PREVIEW ---------------- */

    const renderPreview = () => {
        if (!activePreviewMenu) return <EmptyDashboardState />;
        switch (activePreviewMenu.toLowerCase()) {
            case "insight":
            case "insights":
                return <InsightDashboardPreview insightConfig={insightConfig} reportConfiguration={reportConfiguration} />;
            case "response rate":
                return <ResponseRatePreview />;
            case "respondent report":
                return <RespondentPreview />;
            case "culturemap":
                return <CultureMapPreview />;
            case "question analysis":
                return <QuestionAnalysisPreview />;
            case "download report":
                return <DownloadReportPreview />;
            case "overview":
                return <OverviewPreview />
            case "employee comment":
            case "employee comments":
                return <AllCommentsPreview />
            case "mood-o-meter":
            case "mood o meter":
                return <MoodOMeterPreview />
            case "demographic comparators":
             case "comparators":
                return <DemographicComparator />
            case "statement wise":
            case "statementwise" :
                return <StatementWisePreview />
            case "trends":
            case "detailtrend":
            case "manager trend":
                return <TrendPreview />
            case "manager insight":
                return  <img alt="" src={ManagerInsights} className="w-100" />
            default:
                return (
                    <div className="text-muted text-center mt-5">
                        Preview not available for this menu
                    </div>
                );
        }
    };

    useEffect(() => {
        setLoading(true);
        getReportType();
        getStoreAccoutData();
    }, []);

    return (
        <React.Fragment>
            <section className="Page-Users Page-Reportwise-Menu">
                <div className="breadcrumb_ezi">
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={() => navigate('/dashboard')}>
                            Dashboard
                        </Breadcrumb.Item>
                        {urlParams?.account_id && (
                            <Breadcrumb.Item onClick={() => navigate('/companies')}>
                                Companies
                            </Breadcrumb.Item>
                        )}
                        {companyName && <Breadcrumb.Item>{companyName}</Breadcrumb.Item>}
                    </Breadcrumb>

                    <div className="column-header justify-content-between">
                        <h1 className="page-heading">Report Wise Menu Visibility</h1>
                        <button
                            onClick={saveReportWiseMenu}
                            className="ezi-btn ezi-pink-btn ezi-btn-ripple"> Save
                        </button>
                    </div>
                </div>
                <div className="users-table-content">
                    <div className="form-group">
                        <p className="label">Select Report Type:</p>
                        <Select
                            isMulti
                            options={reportList}
                            value={reportType}
                            styles={outlineRemove}
                            placeholder="Please Select Report Type"
                            onChange={(value) => setReportType(value)}
                            className="multi-report-select"
                        />
                    </div>
                    <div className="selected-wrap">
                        {reportType.map(rep => (
                            <div className="d-flex gap-3 box" key={rep.value}>
                                <p className="m-0">{rep.label}</p>
                                <button
                                    onClick={() => handleReportWiseMenu(rep)}
                                    className="ezi-btn ezi-filter-btn m-0">
                                    Select menu and arrange
                                </button>
                            </div>))}
                    </div>
                </div>
                {showModal && (
                    <Modal show={showModal} className="ezi-modal-wrapper theme-modal-wrapper report-wise-menu-modal" size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
                        <Modal.Header className="ezi-modal-header">
                            <Modal.Title id="contained-modal-title-vcenter" className="theme-modal-title ezi-modal-header-title" >
                                <span className="theme-modal-title-text">Select menu and arrange</span>
                                <span className="ezi-modal-close" onClick={() => { setShowModal(false); setSelectedReport(); setActivePreviewMenu() }}></span>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row h-100">
                                <div className="col-md-3 border-end pe-3">
                                    <h6 className="mb-3">{reportName}</h6>
                                    <Select
                                        isMulti
                                        options={selectedMenuOption}
                                        value={selectedMenu}
                                        placeholder="Select dashboard menus..."
                                        onChange={handleReportMenuSelect}
                                    />
                                    <div className="mt-3">
                                        <DndContext
                                            collisionDetection={closestCenter}
                                            onDragEnd={handleOnDragEnd}>
                                            <SortableContext
                                                items={selectedMenus}
                                                strategy={verticalListSortingStrategy}>
                                                {selectedMenus.map(item => (
                                                    <SortableMenuItem
                                                        key={item}
                                                        id={item}
                                                        isInsight={item.toLowerCase() === "insight" || item.toLowerCase() === "insights"}
                                                        insightConfig={insightConfig}
                                                        onInsightChange={setInsightConfig}
                                                        onReportConfigChange={setReportConfiguration}
                                                        reportConfiguration={reportConfiguration}
                                                        isActive={activePreviewMenu === item}
                                                        onSelectPreview={setActivePreviewMenu}
                                                    />
                                                ))}
                                            </SortableContext>
                                        </DndContext>
                                    </div>
                                </div>
                                <div className="col-md-9 ps-4 bg-light">
                                    <h6 className="mb-3">
                                        Dashboard Preview
                                        {activePreviewMenu && (
                                            <span className="text-muted ms-2">
                                                ({activePreviewMenu})
                                            </span>
                                        )}
                                    </h6>
                                    <div className="mb-3 d-flex me-2 align-items-center">
                                        <h6 className="mb-2 me-3">Default Date Range: </h6>
                                        {[{ label: "Date Range", value: "daterange" },
                                        { label: "Last 7 Days", value: "7days" },
                                        { label: "Last 30 Days", value: "30days" },
                                        { label: "Last 90 Days", value: "90days" }
                                        ].map(opt => (
                                            <div className="form-check me-2" key={opt.value}>
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="defaultDateRange"
                                                    id={`date-range-${opt.value}`}
                                                    checked={reportConfiguration?.date_range === opt.value}
                                                    onChange={() =>
                                                        setReportConfiguration(prev => ({
                                                            ...prev,
                                                            date_range: opt.value
                                                        }))
                                                    }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor={`date-range-${opt.value}`}
                                                >
                                                    {opt.label}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                    {renderPreview()}
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                className="close-theme-btn"
                                onClick={() => {
                                    setShowModal(false);
                                    setSelectedReport(null);
                                    setActivePreviewMenu(null);
                                }}> Close</button>
                            <input
                                type="submit"
                                value="Save"
                                onClick={saveReportWiseMenu}
                                className="btn-ripple ezi-pink-btn add-theme-btn" />
                        </Modal.Footer>
                    </Modal>
                )}
            </section>
            {loading && <EziLoader />}
        </React.Fragment>
    );
};

export default ReportAndMenuAssign;